<app-side-menu>
  <div class="agenda-container">
    
    <!-- Lista de Agendas -->
    <div *ngIf="!isCreating && !isEditing">

      <!-- Tabela de Agendas -->
      <div *ngIf="!error">
        <app-table
          [title]="'Lista de Agendas'"
          [data]="agendas"
          [columns]="columns"
          [loading]="loading"
          [showSearch]="true"
          [searchPlaceholder]="'Buscar por nome...'"
          [actions]="tableActions"
          (searchChange)="onSearchChange($event)"
          (actionClick)="onActionClick($event)">
          <app-button
            table-header-action
            text="Nova Agenda"
            [color]="'var(--primary-light)'"
            [height]="'42px'"
            className="new-agenda-btn"
            (buttonClick)="startCreating()">
          </app-button>
        </app-table>
      </div>

      <!-- Loading -->
      <!-- Error Message -->
      <div *ngIf="error" class="alert alert-danger" role="alert">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            (click)="refreshAgendas()">
            <i class="fas fa-redo me-1"></i>
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>

    <!-- Formulário de Criação/Edição -->
    <div *ngIf="isCreating || isEditing">
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="page-header-form">
            <div class="d-flex align-items-center">
              <button 
                type="button"
                class="btn btn-light me-3"
                (click)="cancelForm()"
                style="background-color: white;">
                <i class="fas fa-arrow-left" style="color: #3A4D56;"></i>
              </button>
              <div>
                <h1 class="page-title-form">
                  <i class="fas fa-calendar-alt me-3"></i>
                  {{ isEditing ? 'Editar Agenda' : 'Nova Agenda' }}
                </h1>
                <p class="page-subtitle">{{ isEditing ? 'Atualize as configurações da agenda' : 'Configure uma nova agenda para o sistema' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card do Formulário -->
      <div class="row">
        <div class="col-12">
          <div class="agenda-form-card">
            <!-- Abas de Navegação -->
            <div class="tabs-container">
              <div class="tabs-header">
                <div class="tab-item" 
                     [class.active]="currentStep === 1"
                     (click)="goToStep(1)">
                  <i class="fas fa-tag"></i>
                  <span>Nome da Agenda</span>
                </div>
                <div class="tab-item" 
                     [class.active]="currentStep === 2"
                     (click)="goToStep(2)">
                  <i class="fas fa-calendar-week"></i>
                  <span>Dias</span>
                </div>
                <div class="tab-item" 
                     [class.active]="currentStep === 3"
                     (click)="goToStep(3)">
                  <i class="fas fa-clock"></i>
                  <span>Horários</span>
                </div>
                <div class="tab-item" 
                     [class.active]="currentStep === 4"
                     (click)="goToStep(4)">
                  <i class="fas fa-eye"></i>
                  <span>Exemplo</span>
                </div>
              </div>
            </div>

            <!-- Step 1: Nome da Agenda -->
            <div *ngIf="currentStep === 1" class="step-content">
              <h3 class="section-title">
                <i class="fas fa-tag me-2"></i>
                Identificação da Agenda
              </h3>
              
              <div class="row g-3">
                <div class="col-md-12">
                  <label for="agendaName" class="form-label">Nome da Agenda *</label>
                  <input 
                    type="text" 
                    id="agendaName"
                    class="form-control" 
                    [(ngModel)]="formData.name"
                    placeholder="Ex: Agenda Comercial, Agenda de Visitas">
                </div>

                <div class="col-md-12">
                  <label for="agendaGroup" class="form-label">Grupo *</label>
                  <select
                    id="agendaGroup"
                    class="form-select"
                    [(ngModel)]="formData.groupId">
                    <option [ngValue]="null">Selecione um grupo</option>
                    <option *ngFor="let group of groups" [ngValue]="group.id">
                      {{ group.name }}
                    </option>
                  </select>
                </div>

                <div class="col-12">
                  <label for="agendaDescription" class="form-label">Descrição</label>
                  <textarea 
                    id="agendaDescription"
                    class="form-control" 
                    rows="3"
                    [(ngModel)]="formData.description"
                    placeholder="Descreva o propósito desta agenda..."></textarea>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch mt-2">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      id="includePresenceStatus"
                      [(ngModel)]="formData.includePresenceStatus">
                    <label class="form-check-label" for="includePresenceStatus">
                      <i class="fas fa-user-check me-2"></i>
                      Incluir status de Presença
                    </label>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch mt-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="canExternalLink"
                      [(ngModel)]="formData.canExternalLink">
                    <label class="form-check-label" for="canExternalLink">
                      <i class="fas fa-external-link-alt me-2"></i>
                      Haverá Agendamento Externo
                    </label>
                    <small class="form-text d-block mt-1">
                      Quando ativado, a agenda permitirá agendamento via link externo
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Dias -->
            <div *ngIf="currentStep === 2" class="step-content">
              <h3 class="section-title">
                <i class="fas fa-calendar-week me-2"></i>
                Configuração de Dias
              </h3>
              
              <div class="row g-4">
                <div class="col-12">
                  <div class="day-selection-mode">
                    <label class="form-label mb-3">Selecione os dias de funcionamento:</label>
                    
                    <div class="btn-group w-100 mb-4" role="group">
                      <input type="radio" class="btn-check" name="dayMode" id="allDays" 
                             [value]="true" [(ngModel)]="formData.allDays" autocomplete="off">
                      <label class="btn btn-outline-primary" for="allDays">
                        <i class="fas fa-calendar me-2"></i>
                        Todos os Dias
                      </label>
                      
                      <input type="radio" class="btn-check" name="dayMode" id="specificDays" 
                             [value]="false" [(ngModel)]="formData.allDays" autocomplete="off">
                      <label class="btn btn-outline-primary" for="specificDays">
                        <i class="fas fa-calendar-check me-2"></i>
                        Dias Específicos
                      </label>
                    </div>

                    <!-- Seleção de dias específicos -->
                    <div *ngIf="!formData.allDays" class="specific-days">
                      <label class="form-label mb-3">Escolha os dias da semana:</label>
                      <div class="days-grid">
                        <div class="day-checkbox" *ngFor="let day of weekDays">
                          <input 
                            type="checkbox" 
                            [id]="'day-' + day.value"
                            [(ngModel)]="day.selected"
                            class="btn-check">
                          <label [attr.for]="'day-' + day.value" class="btn btn-outline-secondary">
                            {{ day.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="holiday-toggle">
                    <div class="form-check form-switch">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        id="excludeHolidays"
                        [(ngModel)]="formData.excludeHolidays">
                      <label class="form-check-label" for="excludeHolidays">
                        <i class="fas fa-umbrella-beach me-2"></i>
                        Excluir Feriados Nacionais
                      </label>
                      <small class="form-text d-block mt-1">
                        Quando ativado, os feriados nacionais serão automaticamente excluídos da agenda
                      </small>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="holiday-toggle">
                    <div class="form-check form-switch">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        id="excludeSpecificDates"
                        [(ngModel)]="formData.excludeSpecificDates">
                      <label class="form-check-label" for="excludeSpecificDates">
                        <i class="fas fa-calendar-times me-2"></i>
                        Excluir Dias Específicos
                      </label>
                      <small class="form-text d-block mt-1">
                        Adicione datas específicas que serão excluídas da agenda
                      </small>
                    </div>

                    <!-- Interface de Adicionar Datas -->
                    <div *ngIf="formData.excludeSpecificDates" class="excluded-dates-section">
                      <div class="add-date-form mb-3">
                        <label class="form-label">Adicionar Data:</label>
                        <div class="d-flex gap-2">
                          <input 
                            type="date" 
                            class="form-control"
                            [(ngModel)]="newExcludedDate"
                            placeholder="Selecione uma data">
                          <button 
                            type="button" 
                            class="btn btn-outline-primary"
                            (click)="addExcludedDate()"
                            [disabled]="!newExcludedDate">
                            <i class="fas fa-plus me-2"></i>
                            Adicionar
                          </button>
                        </div>
                      </div>

                      <!-- Lista de Datas Excluídas -->
                      <div *ngIf="formData.excludedDates && formData.excludedDates.length > 0" class="excluded-dates-list">
                        <label class="form-label">Datas Excluídas:</label>
                        <div class="excluded-dates-grid">
                          <div class="excluded-date-item" *ngFor="let date of formData.excludedDates; let i = index">
                            <span class="date-value">
                              <i class="fas fa-calendar-times me-2"></i>
                              {{ date | date: 'dd/MM/yyyy' }}
                            </span>
                            <button 
                              type="button" 
                              class="btn btn-sm btn-outline-danger"
                              (click)="removeExcludedDate(i)">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Mensagem quando vazio -->
                      <div *ngIf="!formData.excludedDates || formData.excludedDates.length === 0" class="alert alert-info">
                        <i class="fas fa-info-circle me-2"></i>
                        Nenhuma data específica foi adicionada ainda
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 3: Horários -->
            <div *ngIf="currentStep === 3" class="step-content">
              <h3 class="section-title">
                <i class="fas fa-clock me-2"></i>
                Configuração de Horários
              </h3>
              
              <div class="row g-4">
                <div class="col-12">
                  <div class="time-selection-mode">
                    <label class="form-label mb-3">Defina os horários de atendimento:</label>
                    
                    <div class="btn-group w-100 mb-4" role="group">
                      <input type="radio" class="btn-check" name="timeMode" id="commercial" 
                             [value]="true" [(ngModel)]="formData.commercialHours" autocomplete="off">
                      <label class="btn btn-outline-primary" for="commercial">
                        <i class="fas fa-briefcase me-2"></i>
                        Horário Comercial (08:00 - 18:00)
                      </label>
                      
                      <input type="radio" class="btn-check" name="timeMode" id="custom" 
                             [value]="false" [(ngModel)]="formData.commercialHours" autocomplete="off">
                      <label class="btn btn-outline-primary" for="custom">
                        <i class="fas fa-clock me-2"></i>
                        Horários Personalizados
                      </label>
                    </div>

                    <!-- Horários personalizados -->
                    <div *ngIf="!formData.commercialHours" class="custom-times">
                      <label class="form-label mb-3">Adicione os horários disponíveis:</label>
                      
                      <div class="time-slots-list mb-3">
                        <div class="time-slot-item" *ngFor="let slot of formData.timeSlots; let i = index">
                          <div class="time-inputs">
                            <input 
                              type="time" 
                              class="form-control" 
                              [(ngModel)]="slot.start"
                              (change)="calculateEndTime(i)"
                              placeholder="Início">
                            <span class="time-separator">até</span>
                            <input 
                              type="time" 
                              class="form-control" 
                              [(ngModel)]="slot.end"
                              readonly
                              placeholder="Fim">
                          </div>
                          <button 
                            type="button" 
                            class="btn btn-outline-danger btn-sm"
                            (click)="removeTimeSlot(i)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>

                      <button 
                        type="button" 
                        class="btn btn-outline-primary"
                        (click)="addTimeSlot()">
                        <i class="fas fa-plus me-2"></i>
                        Adicionar Horário
                      </button>
                    </div>

                    <!-- Preview do horário comercial -->
                    <div *ngIf="formData.commercialHours" class="commercial-preview alert alert-info">
                      <i class="fas fa-info-circle me-2"></i>
                      <strong>Horário Comercial Padrão:</strong> Segunda a Sexta-feira, das 08:00 às 18:00
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="intervalDuration" class="form-label">Duração dos Intervalos (minutos)</label>
                  <select 
                    id="intervalDuration"
                    class="form-select" 
                    [(ngModel)]="formData.intervalDuration"
                    (change)="recalculateAllEndTimes()">
                    <option value="15">15 minutos</option>
                    <option value="30">30 minutos</option>
                    <option value="45">45 minutos</option>
                    <option value="60">1 hora</option>
                    <option value="90">1 hora e 30 minutos</option>
                    <option value="120">2 horas</option>
                  </select>
                  <small class="form-text">Define a duração de cada slot de agendamento</small>
                </div>

                <div class="col-md-6">
                  <label for="attendancesPerSlot" class="form-label">Atendimentos por Horário</label>
                  <input 
                    type="number" 
                    id="attendancesPerSlot"
                    class="form-control" 
                    [(ngModel)]="formData.attendancesPerSlot"
                    min="1"
                    max="100"
                    placeholder="Ex: 1">
                  <small class="form-text">Quantidade máxima de atendimentos simultâneos por horário</small>
                </div>
              </div>
            </div>

            <!-- Step 4: Exemplo -->
            <div *ngIf="currentStep === 4" class="step-content">
              <h3 class="section-title">
                <i class="fas fa-eye me-2"></i>
                Prévia da Agenda
              </h3>
              
              <div class="row g-4">
                <div class="col-12">
                  <div class="alert alert-info">
                    <i class="fas fa-info-circle me-2"></i>
                    Visualize em modo <strong>Mensal</strong> ou <strong>Semanal</strong> e clique em um dia para ver os horários disponíveis.
                  </div>
                </div>

                <div class="col-12">
                  <!-- Toggle de modo de visualização -->
                  <div class="preview-mode-toggle btn-group mb-3" role="group">
                    <input type="radio" class="btn-check" name="previewMode" id="monthlyMode" 
                           [value]="'monthly'" [(ngModel)]="previewMode" (change)="onPreviewModeChange()" autocomplete="off">
                    <label class="btn btn-outline-primary" for="monthlyMode">
                      <i class="fas fa-calendar-alt me-2"></i>
                      Mensal
                    </label>

                    <input type="radio" class="btn-check" name="previewMode" id="weeklyMode" 
                           [value]="'weekly'" [(ngModel)]="previewMode" (change)="onPreviewModeChange()" autocomplete="off">
                    <label class="btn btn-outline-primary" for="weeklyMode">
                      <i class="fas fa-calendar-week me-2"></i>
                      Semanal
                    </label>
                  </div>

                  <!-- Visualização Mensal -->
                  <div class="calendar-preview" *ngIf="previewMode === 'monthly'">
                    <div class="calendar-grid">
                      <div class="calendar-day" 
                           *ngFor="let day of previewDays"
                           [class.disabled]="!day.available"
                           [class.selected]="selectedPreviewDay === day"
                           (click)="selectPreviewDay(day)">
                        <div class="day-header">
                          <span class="day-name">{{ day.dayName }}</span>
                          <span class="day-number">{{ day.dayNumber }}</span>
                        </div>
                        <div class="day-month">{{ day.monthName }}</div>
                        <div class="day-status" *ngIf="!day.available">
                          <i class="fas fa-ban"></i>
                        </div>
                        <div class="day-status" *ngIf="day.available">
                          <i class="fas fa-check-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Visualização Semanal -->
                  <div class="calendar-preview" *ngIf="previewMode === 'weekly'">
                    <div class="weekly-controls d-flex justify-content-between align-items-center mb-2">
                      <button type="button" class="btn btn-light" (click)="prevWeek()">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                      <div class="week-range text-muted fw-semibold">
                        {{ weeklyDays[0].fullDate | date: 'dd/MM' }} - {{ weeklyDays[6].fullDate | date: 'dd/MM/yyyy' }}
                      </div>
                      <button type="button" class="btn btn-light" (click)="nextWeek()">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                    <div class="calendar-grid weekly-grid">
                      <div class="calendar-day" 
                           *ngFor="let day of weeklyDays"
                           [class.disabled]="!day.available"
                           [class.selected]="selectedPreviewDay === day"
                           (click)="selectPreviewDay(day)">
                        <div class="day-header">
                          <span class="day-name">{{ day.dayName }}</span>
                          <span class="day-number">{{ day.dayNumber }}</span>
                        </div>
                        <div class="day-month">{{ day.monthName }}</div>
                        <div class="day-status" *ngIf="!day.available">
                          <i class="fas fa-ban"></i>
                        </div>
                        <div class="day-status" *ngIf="day.available">
                          <i class="fas fa-check-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Navegação do Formulário -->
            <div *ngIf="currentStep === 3 || currentStep === 4" class="form-navigation mt-4">
              <button 
                type="button" 
                class="btn btn-success" 
                [disabled]="isSaving"
                (click)="saveAgenda()">
                <i class="fas fa-save me-2"></i>
                {{ isSaving ? 'Salvando...' : 'Salvar Agenda' }}
                <span *ngIf="isSaving" class="spinner-border spinner-border-sm ms-2"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal Customizado de Horários -->
  <div class="custom-modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="custom-modal" (click)="$event.stopPropagation()" *ngIf="selectedPreviewDay">
      <div class="custom-modal-header">
        <h5 class="custom-modal-title">
          <i class="fas fa-calendar-day me-2"></i>
          {{ selectedPreviewDay.fullDate | date: 'EEEE, dd/MM/yyyy' }}
        </h5>
        <button type="button" class="custom-modal-close" (click)="closeModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="custom-modal-body">
        <!-- Dia Disponível -->
        <div *ngIf="selectedPreviewDay.available">
          <div class="alert alert-success mb-3">
            <i class="fas fa-check-circle me-2"></i>
            <strong>Dia Disponível!</strong> Veja os horários disponíveis abaixo:
          </div>
          
          <div class="time-slots-modal-grid">
            <div class="time-slot-modal-item" *ngFor="let slot of selectedPreviewDay.timeSlots">
              <div class="slot-time">
                <i class="fas fa-clock me-2"></i>
                <span class="time-range">{{ slot.start }} - {{ slot.end }}</span>
              </div>
              <div class="slot-capacity" *ngIf="slot.capacity">
                <i class="fas fa-users me-1"></i>
                <span class="capacity-text">{{ slot.capacity }} {{ slot.capacity === 1 ? 'vaga' : 'vagas' }}</span>
              </div>
            </div>
          </div>

          <div class="modal-footer-info mt-3">
            <small class="text-muted">
              <i class="fas fa-info-circle me-1"></i>
              Total de {{ selectedPreviewDay.timeSlots.length }} horários disponíveis
              <span *ngIf="formData.attendancesPerSlot > 1">
                ({{ selectedPreviewDay.timeSlots.length * formData.attendancesPerSlot }} vagas totais)
              </span>
            </small>
          </div>
        </div>

        <!-- Dia Indisponível -->
        <div *ngIf="!selectedPreviewDay.available">
          <div class="alert alert-warning mb-0">
            <div class="d-flex align-items-start">
              <i class="fas fa-exclamation-triangle me-3 mt-1" style="font-size: 1.5rem;"></i>
              <div>
                <h6 class="alert-heading mb-2">Dia Indisponível</h6>
                <p class="mb-0">
                  <span *ngIf="selectedPreviewDay.reason === 'holiday'">
                    Este dia foi excluído por ser um <strong>Feriado Nacional</strong>.
                  </span>
                  <span *ngIf="selectedPreviewDay.reason === 'excluded'">
                    Este dia foi <strong>excluído especificamente</strong> das configurações da agenda.
                  </span>
                  <span *ngIf="selectedPreviewDay.reason === 'weekday'">
                    Este dia da semana <strong>não está configurado</strong> para atendimento.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="custom-modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="fas fa-times me-2"></i>
          Fechar
        </button>
      </div>
    </div>
  </div>
</app-side-menu>
